// extracted by mini-css-extract-plugin
export default {"editorContainer":"simplicity-composer-tiptap_editorContainer__1sY3M","editor":"simplicity-composer-tiptap_editor__8yX50"};